import { LoadStatusModel } from '@modules/shared/models/common';

export interface UserLoadStatusViewModel extends LoadStatusModel {
    isSearching: boolean;
    isSearched: boolean;
}
